import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_767 } from '~/src/styles/tokens/break-points';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import MainButton from '~/src/components/form-components/main-button/main-button';
import type { TextAlign } from '~/src/components/common-components/popup-content/popup-content.types';

export const PopupContainer = styled.div<{ width: number; minWidth?: number; gapContainer?: number; }>`
    display: flex;
    max-width: ${(p) => rem(p.width)};
    min-width: ${p => p.minWidth ? rem(p.minWidth) : 'auto'};
    gap: ${(p) => p.gapContainer ? rem(p.gapContainer) : rem(32)};
    flex-direction: column;
`;

export const TextContainer = styled.div`
    display: inherit;
    flex-direction: inherit;
    gap: ${rem(16)};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: ${rem(16)};

    ${mediaQuery({ maxWidth: MAX_767 }, css`
        flex-direction: column-reverse;
    `)};
`;

export const Title = styled.h2<{ textAlign?: TextAlign; fontSize?: string; }>`
    ${p => p.fontSize || FONTS.compact.medium.size24};
    text-align: ${p => p.textAlign};
`;

export const SubText = styled.span<{ textAlign?: TextAlign; fontSize?: string;}>`
    ${p => p.fontSize || FONTS.compact.regular.size17};
    text-align: ${p => p.textAlign};
`;

export const Button = styled(MainButton)`
    max-width: 100%;
    width: 100% !important;
    height: ${rem(44)};
    padding: ${rem(10)} ${rem(12)};
    ${FONTS.compact.medium.size17};
`;